<template>
  <div class="mt-3">
    <v-row>
      <v-col cols="12" lg="4" class="d-flex flex-column">
        <v-card class="rounded-lg shadow flex d-flex flex-column">
          <v-card-title>
            Tentatives par genre
          </v-card-title>
          <v-divider></v-divider>

          <v-card-text v-if="isLoading">
            <v-skeleton-loader type="image"/>
          </v-card-text>

          <v-card-text class="flex" v-else>
            <apexchart
                type="pie"
                height="300"
                :options="genderChartOptions"
                :series="genderChartSeries"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" lg="4" class="d-flex flex-column">
        <v-card class="rounded-lg shadow flex d-flex flex-column">
          <v-card-title>
            Visites par langue
          </v-card-title>
          <v-divider></v-divider>

          <v-card-text v-if="isLoading">
            <v-skeleton-loader type="image"/>
          </v-card-text>

          <v-card-text class="flex" v-else>
            <apexchart
                type="donut"
                height="300"
                :options="languageChartOptions"
                :series="languageChartSeries"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" lg="4" class="d-flex flex-column">
        <v-card class="rounded-lg shadow flex d-flex flex-column">
          <v-card-title>
            Visites par SE
          </v-card-title>
          <v-divider></v-divider>

          <v-card-text v-if="isLoading">
            <v-skeleton-loader type="image"/>
          </v-card-text>

          <v-card-text class="flex" v-else>
            <apexchart
                type="pie"
                height="300"
                :options="osChartOptions"
                :series="osChartSeries"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";

export default {
  props: ['boosting_method_id'],
  data() {
    return {
      isLoading: false,
      by_gender: [],
      by_os: [],
      by_language: [],
    }
  },
  methods: {
    getAttemptsGraph() {
      this.isLoading = true
      if (!this.boosting_method_id) return;
      HTTP.get('/v1/boosting-methods/dashboard/attempts-graph', {
        params: {
          boosting_method_id: this.boosting_method_id
        }
      }).then(res => {
        this.isLoading = false
        this.by_gender = res.data.data.by_gender
        this.by_os = res.data.data.by_os
        this.by_language = res.data.data.by_language

      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
  },
  computed: {
    genderChartOptions() {
      return {
        labels: this.by_gender.map(item => item.gender),
        legend: {
          position: 'bottom',
          horizontalAlign: 'center'
        }
      }
    },
    genderChartSeries() {
      return this.by_gender.map(item => item.total)
    },
    languageChartOptions() {
      return {
        labels: this.by_language.map(item => item.os_language),
        legend: {
          position: 'bottom',
          horizontalAlign: 'center'
        }
      }
    },
    languageChartSeries() {
      return this.by_language.map(item => item.total)
    },
    osChartOptions() {
      return {
        labels: this.by_os.map(item => item.os_group),
        legend: {
          position: 'bottom',
          horizontalAlign: 'center'
        }
      }
    },
    osChartSeries() {
      return this.by_os.map(item => item.total)
    }
  },
  created() {
    this.getAttemptsGraph()
  },
  watch: {
    boosting_method_id(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getAttemptsGraph();
      }
    }
  }
}
</script>

<style>

</style>